import yup from "yup";
import { compose, withProps } from "recompose";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { fetchApi } from "core/api/hoc";
import qs from "query-string";
import { withActions } from "core/redux/hoc";
import { createErrorsSelector } from "core/helpers";
import * as api from "modules/user/auth/api";
import * as selectors from "modules/user/auth/selectors";
import { unauthenticated } from "modules/user/auth/hoc";
import View from "./View";

export default compose(
  unauthenticated,
  fetchApi(api.getDiscountInfo, ({ location }) => ({
    key: "offer",
    selector: selectors.getDiscountInfoApi,
    payload: {
      code: qs.parse(location.search).code
    }
  })),
  withProps(({ location }) => ({
    referral_key: qs.parse(location.search).referral_key
  })),
  connect(
    createStructuredSelector({
      signUpApi: selectors.signUpApi,
      linkedInSignInApi: selectors.linkedInSignInApi,
      errors: createErrorsSelector(
        selectors.signUpApi,
        selectors.linkedInSignInApi
      )
    }),
    dispatch => referral_key => ({
      onSignInSuccess: () =>
        dispatch(
          api.linkedInSignIn.request({
            body: { access_token: window.IN.ENV.auth.oauth_token }
          })
        )
    })
  ),
  withActions({
    onSubmit: ({ referral_key }) => (
      { password_confirmation, ...values },
      { setErrors }
    ) => {
      if (values.password !== password_confirmation) {
        return setErrors({
          password_confirmation: "Passwords are not matching"
        });
      }
      const payload = {
        ...values,
        referral_key
      };
      return api.signUp.request({ body: payload });
    }
  }),
  withProps({
    validationSchema: yup.object().shape({
      first_name: yup.string().required("First name is required"),
      last_name: yup.string().required("Last name is required"),
      email: yup
        .string()
        .required("Email is required")
        .email("Is not valid email"),
      password: yup
        .string()
        .required("Password is required")
        .min(8, "Password should be at least 8 characters length"),
      password_confirmation: yup
        .string()
        .required("Password confirmation is required"),
      resume: yup.mixed().required("Resume is required")
    })
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/SignUp/Provider.js